// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QHog","option":"styles_option__15JTT","active":"styles_active__nYAif"};